<!--Info-->
<div>
	<div class="TitleBorder">
		<h4>Data Validity Checks for:</h4>
		<h4 class="SchoolName">{{ SchoolFullName }}</h4>
	</div>

	<!--Semester-->
	<div class="ItemBorder">
		<div class="InnerGrid">
			<label>Semester Validity:</label>

			<div>
				<i *ngIf="loading == true" class="p-datatable-loading-icon pi pi-spin pi-spinner LoadingFont" aria-hidden="true"></i>
				<i *ngIf="loading == false && SemesterStatusID == 0" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && SemesterStatusID == 1" class="fa fa-exclamation-triangle IconFont WarningColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && SemesterStatusID == 2" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
			</div>

			<label *ngIf="loading == false" class="MessageText">{{ SemesterMessage }}</label>
			<label *ngIf="loading == true">{{ LoadingText }}</label>

			<button [disabled]="loading == true || CanAccessSemester == false" class="btn btn-primary ViewButton" (click)="onViewSemester()">View</button>
		</div>
		<!-- <div *ngIf="lstErrorSemester.length > 0 || lstWarningSemester.length > 0">
            <div class="SchoolListDiv">
                <label>School(s):</label>

                <label *ngFor="let o of lstErrorSemester; index as i;" style="color: red;">{{o.SchoolNumber}}{{i < (lstErrorSemester.length - 1) + (lstWarningSemester.length) ? ', ' : ''}}</label>
                <label *ngFor="let o of lstWarningSemester; index as i;"  style="color: orange;">{{o.SchoolNumber}}{{i < (lstWarningSemester.length - 1) ? ', ' : ''}}</label>
            </div>
        </div> -->
	</div>

	<!--School Day-->
	<div class="ItemBorder ItemMargin">
		<div class="InnerGrid">
			<label>School Day Validity:</label>

			<div>
				<i *ngIf="loading == true" class="p-datatable-loading-icon pi pi-spin pi-spinner LoadingFont" aria-hidden="true"></i>
				<i *ngIf="loading == false && SchoolDayStatusID == 0" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && SchoolDayStatusID == 1" class="fa fa-exclamation-triangle IconFont WarningColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && SchoolDayStatusID == 2" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
			</div>

			<label *ngIf="loading == false" class="MessageText">{{ SchoolDayMessage }}</label>
			<label *ngIf="loading == true">{{ LoadingText }}</label>

			<button [disabled]="loading == true || CanAccessSchoolDay == false" class="btn btn-primary ViewButton" (click)="onViewSchoolDay()">View</button>
		</div>
		<!-- <div *ngIf="lstErrorSchoolDay.length > 0 || lstWarningSchoolDay.length > 0">
            <div class="SchoolListDiv">
                <label>School(s):</label>

                <label *ngFor="let o of lstErrorSchoolDay; index as i;" style="color: red;">{{o.SchoolNumber}}{{i < (lstErrorSchoolDay.length - 1) + (lstWarningSchoolDay.length) ? ', ' : ''}}</label>
                <label *ngFor="let o of lstWarningSchoolDay; index as i;"  style="color: orange;">{{o.SchoolNumber}}{{i < (lstWarningSchoolDay.length - 1) ? ', ' : ''}}</label>
            </div>
        </div> -->
	</div>

	<!--Calendar-->
	<div class="ItemBorder ItemMargin">
		<div class="InnerGrid">
			<label>Calendar Validity:</label>

			<div>
				<i *ngIf="loading == true" class="p-datatable-loading-icon pi pi-spin pi-spinner LoadingFont" aria-hidden="true"></i>
				<i *ngIf="loading == false && CalendarStatusID == 0" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && CalendarStatusID == 1" class="fa fa-exclamation-triangle IconFont WarningColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && CalendarStatusID == 2" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
			</div>

			<label *ngIf="loading == false" class="MessageText">{{ CalendarMessage }}</label>
			<label *ngIf="loading == true">{{ LoadingText }}</label>

			<button [disabled]="loading == true || CanAccessCalendar == false" class="btn btn-primary ViewButton" (click)="onViewCalendar()">View</button>
		</div>
		<!-- <div *ngIf="lstErrorCalendar.length > 0 || lstWarningCalendar.length > 0">
            <div class="SchoolListDiv">
                <label>School(s):</label>

                <label *ngFor="let o of lstErrorCalendar; index as i;" style="color: red;">{{o.SchoolNumber}}{{i < (lstErrorCalendar.length - 1) + (lstWarningCalendar.length) ? ', ' : ''}}</label>
                <label *ngFor="let o of lstWarningCalendar; index as i;"  style="color: orange;">{{o.SchoolNumber}}{{i < (lstWarningCalendar.length - 1) ? ', ' : ''}}</label>
            </div>
        </div> -->
	</div>

	<!--Period-->
	<div class="ItemBorder ItemMargin">
		<div class="InnerGrid">
			<label>Period Validity:</label>

			<div>
				<i *ngIf="loading == true" class="p-datatable-loading-icon pi pi-spin pi-spinner LoadingFont" aria-hidden="true"></i>
				<i *ngIf="loading == false && PeriodStatusID == 0" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && PeriodStatusID == 1" class="fa fa-exclamation-triangle IconFont WarningColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && PeriodStatusID == 2" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
			</div>

			<label *ngIf="loading == false" class="MessageText">{{ PeriodMessage }}</label>
			<label *ngIf="loading == true">{{ LoadingText }}</label>

			<button [disabled]="loading == true || CanAccessPeriod == false" class="btn btn-primary ViewButton" (click)="onViewPeriod()">View</button>
		</div>
		<!-- <div *ngIf="lstErrorPeriod.length > 0 || lstWarningPeriod.length > 0">
            <div class="SchoolListDiv">
                <label>School(s):</label>

                <label *ngFor="let o of lstErrorPeriod; index as i;" style="color: red;">{{o.SchoolNumber}}{{i < (lstErrorPeriod.length - 1) + (lstWarningPeriod.length) ? ', ' : ''}}</label>
                <label *ngFor="let o of lstWarningPeriod; index as i;"  style="color: orange;">{{o.SchoolNumber}}{{i < (lstWarningPeriod.length - 1) ? ', ' : ''}}</label>
            </div>
        </div> -->
	</div>

	<!--Tardy Time-->
	<div class="ItemBorder ItemMargin">
		<div class="InnerGrid">
			<label>Tardy Time Validity:</label>

			<div>
				<i *ngIf="loading == true" class="p-datatable-loading-icon pi pi-spin pi-spinner LoadingFont" aria-hidden="true"></i>
				<i *ngIf="loading == false && TardyTimeStatusID == 0" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && TardyTimeStatusID == 1" class="fa fa-exclamation-triangle IconFont WarningColor" aria-hidden="true"></i>
				<i *ngIf="loading == false && TardyTimeStatusID == 2" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
			</div>

			<label *ngIf="loading == false" class="MessageText">{{ TardyTimeMessage }}</label>
			<label *ngIf="loading == true">{{ LoadingText }}</label>

			<button [disabled]="loading == true || CanAccessTardyTime == false" class="btn btn-primary ViewButton" (click)="onViewTardyTime()">View</button>
		</div>
		<!-- <div *ngIf="lstErrorTardyTime.length > 0 || lstWarningTardyTime.length > 0">
            <div class="SchoolListDiv">
                <label>School(s):</label>

                <label *ngFor="let o of lstErrorTardyTime; index as i;" style="color: red;">{{o.SchoolNumber}}{{i < (lstErrorTardyTime.length - 1) + (lstWarningTardyTime.length) ? ', ' : ''}}</label>
                <label *ngFor="let o of lstWarningTardyTime; index as i;"  style="color: orange;">{{o.SchoolNumber}}{{i < (lstWarningTardyTime.length - 1) ? ', ' : ''}}</label>
            </div>
        </div> -->
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
